// Local types (shared/* will be provided by another worker; duplicated here for compilation)
export interface Vec3 { x: number; y: number; z: number }

export enum CommandType {
    Move = 'move',
    ActivateCard = 'activate_card',
    DiscardCard = 'discard_card',
    SetTarget = 'set_target',
    CancelOrder = 'cancel_order',
    TriggerAbility = 'trigger_ability',
    FireBasic = 'fire_basic',
    DismissDrone = 'dismiss_drone',
    AdminSpawnDummy = 'admin_spawn_dummy',
    AdminDamageSelf = 'admin_damage_self',
    AdminResetArena = 'admin_reset_arena',
}

export interface MoveCommand { type: CommandType.Move; direction: { x: number; y: number; z: number }; speed: number }
export interface ActivateCardCommand { type: CommandType.ActivateCard; cardSlot: number }
export interface DiscardCardCommand { type: CommandType.DiscardCard; cardSlot: number }
export interface SetTargetCommand { type: CommandType.SetTarget; targetId: string; worldPos: { x: number; y: number; z: number } }
export interface CancelOrderCommand { type: CommandType.CancelOrder }
export interface TriggerAbilityCommand { type: CommandType.TriggerAbility; droneId: string; direction?: Vec3 }
export interface FireBasicCommand { type: CommandType.FireBasic; direction?: Vec3 }
export interface DismissDroneCommand { type: CommandType.DismissDrone; droneId: string }
export interface AdminSpawnDummyCommand { type: CommandType.AdminSpawnDummy }
export interface AdminDamageSelfCommand { type: CommandType.AdminDamageSelf }
export interface AdminResetArenaCommand { type: CommandType.AdminResetArena }

export type PlayerCommand =
    | MoveCommand
    | ActivateCardCommand
    | DiscardCardCommand
    | SetTargetCommand
    | CancelOrderCommand
    | TriggerAbilityCommand
    | FireBasicCommand
    | DismissDroneCommand
    | AdminSpawnDummyCommand
    | AdminDamageSelfCommand
    | AdminResetArenaCommand;
